import useSWR from 'swr';

import ENDPOINTS from '../ENDPOINTS';

import fetcherWithAuth from './utils/fetcherWithAuth';

const useBox = (id, token) =>
  useSWR(
    id && token ? [`${ENDPOINTS.boxes}/${id}`, token] : null,
    fetcherWithAuth
  );

export default useBox;
